import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "controller_name",
  "use": "controller_name-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"controller_name\"><path d=\"M12.227 8.228l-3.354 3.21a1.622 1.622 0 102.667 1.666l1.415-4.422a.443.443 0 00-.728-.454zm2.482-3.166A6.996 6.996 0 005.063 7.29 7.001 7.001 0 0010.993 18 7 7 0 0014.71 5.062zm.956 8.852a5.473 5.473 0 01-4.67 2.586 5.496 5.496 0 01-2.909-.836 5.507 5.507 0 01-1.75-7.579A5.477 5.477 0 0111.008 5.5c1.026 0 2.031.29 2.907.836a5.508 5.508 0 011.75 7.579z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol